// @ts-nocheck
import React from 'react'
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import * as R from 'ramda'

import { Box } from 'components/layout/Box/Box'
import { List } from 'components/shared/List/List'
import { SnackbarContent } from './common/SnackbarContent/SnackbarContent'

import styles from './Snackbar.module.scss'

const DEFAULT_SPACING = 62.5

export const Snackbar = ({ delay = 200, snacks, onDismiss }) => (
  <List>
    <TransitionGroup>
      {R.pipe(
        R.addIndex(R.map)(({ id, message, ref, type }, index) => (
          <CSSTransition
            className={styles.snackbar}
            classNames={{
              enter: styles.enter,
              enterActive: styles.enterActive,
              exit: styles.exit,
              exitActive: styles.exitActive,
            }}
            key={id}
            nodeRef={ref}
            timeout={delay}
          >
            <List.Item
              role="presentation"
              style={{ bottom: `${index * DEFAULT_SPACING}px` }}
              {...{ ref }}
            >
              <Box className={styles.content}>
                <SnackbarContent {...{ id, message, type, onDismiss }} />
              </Box>
            </List.Item>
          </CSSTransition>
        )),
      )(snacks)}
    </TransitionGroup>
  </List>
)
